<template>
  <div class="page">
    <Header title="选择转移对象"></Header>
    <div class="clint-info-box">

      <div class="worker-info">
        <div v-for="(item,index) of clientUserList" @click="TransferWorkshop(item.clientUserId)" class="worker-info-item" :key="index">
          <img :src="$getImgUrl()" class="head-portrait"/>
          <div class="worker-info-detail">
            <div class="worker-info-detail-name">{{item.userName}}-{{item.userMobile}}</div>
            <div class="worker-info-detail-point">已获得积分：145000</div>
            <div :class="['worker-info-detail-role',item.userRole==='02'?'worker-info-detail-role02':'worker-info-detail-role03']">{{item.userRoleName}}</div>
          </div>
          <div v-show="item.clientId!==clientId" class="change-btn">选择</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import centerApi from '@/api/center.js'
export default {
  components: { Header },
  data () {
    return {
      clientUserList: [],
      clientId: ''
    }
  },
  created () {
    this.queryClientUserList()
  },
  methods: {
    queryClientUserList () {
      centerApi.queryClientUserList().then(res => {
        if (res.data.resultCode === '0') {
          this.clientUserList = res.data.resultData.clientUserList
        }
      })
    },
    TransferWorkshop (clientUserId) {
      this.$router.push({ name: 'workshop-transfer', query: { clientUserId } })
    }
  }
}
</script>

<style lang="less" scoped>
.worker-info{
  margin: 20px  15px 0   15px;
  width: calc(100% - 30px);
}
.worker-info-item{
  background-color: #fff;
  border-radius: 5px;
  margin: 15px 0px;
  height: 80px;
  display: flex;
  position: relative;
  .head-portrait{
    margin: 10px;
    border-radius: 5px;
    vertical-align: middle;
  }
  .worker-info-detail{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .worker-info-detail-name{
    font-size: 16px;
    color: black;
  }
  .worker-info-detail-point{
    color: grey;
    font-size: 12px;
  }
  .worker-info-detail-role{
    text-align: center;
    font-size: 12px;
    padding: 2px;
    width: 30px;
    background-color: rgb(238, 234, 174);
    border-radius: 5px;
  }
}
.head-portrait{
  width: 60px;
  height: 60px;
}
  .change-btn{
    background-color: var(--base-green);
    text-align: center;
    color: white;
    border-radius: 12px;
    position: absolute;
    font-size: 12px;
    padding: 5px 17px;
    right: 10px;
    bottom: 6px;
  }
.worker-info-detail-role03{
    background-color: #e2eef0;
    color: #117181;
  }
  .worker-info-detail-role02{
    background-color: #f8f7db;
    color: #b9b56e;
  }
</style>
